import "./style.css";
import {
  SiReact,
  SiJavascript,
  SiTypescript,
  SiVuedotjs,
  SiNodedotjs,
  SiFigma,
  SiDocker,
  SiGit,
  SiFirebase,
  SiTailwindcss,
} from "react-icons/si";
import { AiFillGithub, AiOutlineInstagram, AiFillLinkedin, AiOutlineLink } from "react-icons/ai";
import { useLanguage } from "../../context/LanguageContext";

const copy = {
  tr: {
    heroName: "Rukiye",
    heroTitle: "Modern web deneyimleri inşa ediyorum.",
    heroDescription:
      "Frontend Geliştirici ve Teknoloji İçerik Üreticisi. Modern web deneyimleri inşa ediyorum ve geliştirici topluluğuyla yolculuğumu paylaşıyorum.",
    heroPrimary: "Konuşalım",
    heroSecondary: "Buralardan Ulaş",
    years: "Yıllık Deneyim",
    projects: "Tamamlanan Proje",
    contribution: "Katkı",
    journeyTitle: "Kariyer Yolculuğum",
    journeyDescription: "Öğrenme döneminden profesyonel üretim sürecine uzanan yolculuk.",
    techTitle: "Teknolojiler",
    techDescription: "Fikirleri hayata geçirmek için kullandığım araçlar.",
    reachTitle: "Buralardan Ulaşabilirsiniz",
    reachDescription: "GitHub, LinkedIn, Instagram, blog ve bilet projesi bağlantıları.",
    contactTitle: "İletişime Geç",
    contactDescription: "Aklınızda bir proje mi var? Birlikte üretelim.",
    namePlaceholder: "Adınız",
    mailPlaceholder: "ornek@email.com",
    messagePlaceholder: "Projeniz hakkında bilgi verin...",
    sendButton: "Mesaj Gönder",
  },
  en: {
    heroName: "Rukiye",
    heroTitle: "I build modern web experiences.",
    heroDescription:
      "Frontend Developer and Tech Content Creator. I build modern web experiences and share my journey with the developer community.",
    heroPrimary: "Let's Talk",
    heroSecondary: "Reach Out",
    years: "Years of Experience",
    projects: "Completed Projects",
    contribution: "Contributions",
    journeyTitle: "Career Journey",
    journeyDescription: "From learning phase to professional product delivery.",
    techTitle: "Technologies",
    techDescription: "Tools I use to turn ideas into products.",
    reachTitle: "Reach Me Here",
    reachDescription: "GitHub, LinkedIn, Instagram, blog, and ticket project links.",
    contactTitle: "Get In Touch",
    contactDescription: "Do you have a project in mind? Let's build it together.",
    namePlaceholder: "Your name",
    mailPlaceholder: "example@email.com",
    messagePlaceholder: "Tell me about your project...",
    sendButton: "Send Message",
  },
};

const timelineByLanguage = {
  tr: [
    {
      year: "2018 - 2023",
      title: "Gazi Üniversitesi",
      text: "Lisans Derecesi, Computer Engineering. Not: 3.20.",
    },
    {
      year: "Eyl 2020 - Tem 2021",
      title: "Game Developer · GA Software",
      text: "C#, Unity ve oyun geliştirme süreçlerinde aktif rol aldım.",
    },
    {
      year: "Tem 2021 - Ara 2021",
      title: "Junior Frontend Developer · Bulut Uygulama Bilgi Teknolojileri A.Ş",
      text: "React Native ve modern frontend akışlarıyla ürün geliştirdim.",
    },
    {
      year: "Ara 2021 - Tem 2023",
      title: "Junior Software Developer · Nanodems",
      text: "Yarı zamanlı. CSS, C# ve web geliştirme projelerinde çalıştım.",
    },
    {
      year: "Şub 2022",
      title: "Software Development Intern · Nanodems",
      text: "JavaScript ve .NET odaklı kısa dönem staj.",
    },
    {
      year: "Tem 2023 - Devam ediyor",
      title: "Software Engineer · Nanodems",
      text: "React Native ve React.js ile ürün geliştirme, ölçeklenebilir arayüzler.",
    },
  ],
  en: [
    {
      year: "2018 - 2023",
      title: "Gazi University",
      text: "BSc, Computer Engineering. GPA: 3.20.",
    },
    {
      year: "Sep 2020 - Jul 2021",
      title: "Game Developer · GA Software",
      text: "Worked actively on game development workflows with C# and Unity.",
    },
    {
      year: "Jul 2021 - Dec 2021",
      title: "Junior Frontend Developer · Bulut Uygulama Bilgi Teknolojileri A.Ş",
      text: "Built product features with React Native and modern frontend practices.",
    },
    {
      year: "Dec 2021 - Jul 2023",
      title: "Junior Software Developer · Nanodems",
      text: "Part-time role focused on CSS, C#, and web development projects.",
    },
    {
      year: "Feb 2022",
      title: "Software Development Intern · Nanodems",
      text: "Short-term internship on JavaScript and .NET.",
    },
    {
      year: "Jul 2023 - Present",
      title: "Software Engineer · Nanodems",
      text: "Building scalable product interfaces with React Native and React.js.",
    },
  ],
};

const techStack = [
  { label: "React", icon: SiReact },
  { label: "JavaScript", icon: SiJavascript },
  { label: "TypeScript", icon: SiTypescript },
  { label: "Vue", icon: SiVuedotjs },
  { label: "Node.js", icon: SiNodedotjs },
  { label: "Firebase", icon: SiFirebase },
  { label: "Tailwind", icon: SiTailwindcss },
  { label: "Figma", icon: SiFigma },
  { label: "Docker", icon: SiDocker },
  { label: "Git", icon: SiGit },
];

const reachCardsByLanguage = {
  tr: [
    {
      name: "GitHub",
      handle: "rukitech",
      stats: ["83+ repo", "Açık kaynak", "Kod ve deneyler"],
      action: "Profili Aç",
      icon: AiFillGithub,
      url: "https://github.com/rukitech",
    },
    {
      name: "LinkedIn",
      handle: "Rukiye İrem Sarısoy",
      stats: ["Deneyimler", "Profesyonel ağ", "Kariyer güncellemeleri"],
      action: "Profili Aç",
      icon: AiFillLinkedin,
      url: "https://www.linkedin.com/in/rukiyeiremsarisoy/",
    },
    {
      name: "Instagram",
      handle: "@rukiblog",
      stats: ["İçerikler", "Reels", "Günlük paylaşımlar"],
      action: "Takip Et",
      icon: AiOutlineInstagram,
      url: "https://www.instagram.com/rukiblog/",
    },
    {
      name: "Kişisel Blog",
      handle: "irem-blog.vercel.app",
      stats: ["Blog yazıları", "Frontend notları", "Portfolio içerikleri"],
      action: "Siteye Git",
      icon: AiOutlineLink,
      url: "https://irem-blog.vercel.app",
    },
    {
      name: "Bilet Al Repo",
      handle: "biletos-website",
      stats: ["JavaScript", "Bilet akışı", "Repo bağlantısı"],
      action: "Repoyu Aç",
      icon: AiFillGithub,
      url: "https://github.com/rukitech/biletos-website",
      featured: true,
    },
  ],
  en: [
    {
      name: "GitHub",
      handle: "rukitech",
      stats: ["83+ repositories", "Open source", "Code and experiments"],
      action: "Open Profile",
      icon: AiFillGithub,
      url: "https://github.com/rukitech",
    },
    {
      name: "LinkedIn",
      handle: "Rukiye Irem Sarisoy",
      stats: ["Experience", "Professional network", "Career updates"],
      action: "Open Profile",
      icon: AiFillLinkedin,
      url: "https://www.linkedin.com/in/rukiyeiremsarisoy/",
    },
    {
      name: "Instagram",
      handle: "@rukiblog",
      stats: ["Content", "Reels", "Daily updates"],
      action: "Follow",
      icon: AiOutlineInstagram,
      url: "https://www.instagram.com/rukiblog/",
    },
    {
      name: "Personal Blog",
      handle: "irem-blog.vercel.app",
      stats: ["Articles", "Frontend notes", "Portfolio content"],
      action: "Visit Site",
      icon: AiOutlineLink,
      url: "https://irem-blog.vercel.app",
    },
    {
      name: "Ticket Repo",
      handle: "biletos-website",
      stats: ["JavaScript", "Ticket flow", "Repository link"],
      action: "Open Repo",
      icon: AiFillGithub,
      url: "https://github.com/rukitech/biletos-website",
      featured: true,
    },
  ],
};

function Home() {
  const { language } = useLanguage();
  const t = copy[language] || copy.tr;
  const timeline = timelineByLanguage[language] || timelineByLanguage.tr;
  const reachCards = reachCardsByLanguage[language] || reachCardsByLanguage.tr;

  return (
    <div className="home" id="home">
      <div className="home-bg">
        <span className="orb orb-1" />
        <span className="orb orb-2" />
        <span className="orb orb-3" />
        <span className="grid-glow" />
      </div>

      <section className="hero section">
        <div className="container hero-inner">
          <h1 className="hero-title">
            {language === "tr" ? "Merhaba, Ben " : "Hi, I'm "}
            <span className="gradient-text">{t.heroName}</span>
          </h1>
          <p className="hero-subtitle">{t.heroTitle}</p>
          <p className="hero-desc">{t.heroDescription}</p>
          <div className="hero-actions">
            <a className="glass-button" href="/#contact">{t.heroPrimary}</a>
            <a className="glass-button-outline" href="/#reach">{t.heroSecondary}</a>
          </div>
          <div className="hero-stats">
            <div>
              <span>6+</span>
              <small>{t.years}</small>
            </div>
            <div>
              <span>23+</span>
              <small>{t.projects}</small>
            </div>
            <div>
              <span>100+</span>
              <small>{t.contribution}</small>
            </div>
          </div>
        </div>
      </section>

      <section className="section about" id="about">
        <div className="container">
          <div className="section-head">
            <h2 className="gradient-text">{t.journeyTitle}</h2>
            <p>{t.journeyDescription}</p>
          </div>

          <div className="timeline">
            <div className="timeline-line" />
            <div className="timeline-items">
              {timeline.map((item) => (
                <div className="timeline-card panel-card" key={item.year}>
                  <div className="timeline-year">{item.year}</div>
                  <h4>{item.title}</h4>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section tech" id="tech">
        <div className="container">
          <div className="section-head">
            <h2 className="gradient-text">{t.techTitle}</h2>
            <p>{t.techDescription}</p>
          </div>
          <div className="tech-grid">
            {techStack.map((tech) => {
              const Icon = tech.icon;
              return (
                <div className="tech-card panel-card" key={tech.label}>
                  <Icon />
                  <span>{tech.label}</span>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section reach" id="reach">
        <div className="container">
          <div className="section-head">
            <h2 className="gradient-text">{t.reachTitle}</h2>
            <p>{t.reachDescription}</p>
          </div>
          <div className="social-grid">
            {reachCards.map((item) => {
              const Icon = item.icon;
              return (
                <div className="social-card panel-card" key={item.name}>
                  {item.featured && <span className="reach-badge">Featured Repo</span>}
                  <div className="social-head">
                    <span className="social-icon"><Icon /></span>
                    <div>
                      <h4>{item.handle}</h4>
                      <p>{item.name}</p>
                    </div>
                  </div>
                  <div className="social-stats">
                    {item.stats.map((stat) => (
                      <span key={stat}>{stat}</span>
                    ))}
                  </div>
                  <a className="glass-button-outline reach-link" href={item.url} target="_blank" rel="noreferrer noopener">
                    {item.action}
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section contact" id="contact">
        <div className="container">
          <div className="section-head">
            <h2 className="gradient-text">{t.contactTitle}</h2>
            <p>{t.contactDescription}</p>
          </div>
          <div className="contact-card panel-card">
            <form className="contact-form">
              <input className="glass-input" placeholder={t.namePlaceholder} />
              <input className="glass-input" placeholder={t.mailPlaceholder} />
              <textarea className="glass-input" placeholder={t.messagePlaceholder} rows="4" />
              <button className="glass-button" type="button">{t.sendButton}</button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
